export class PropostaPrestacaoLegacy {
    constructor(id, numero, valor, dataVencimento, dataAjustePreco) {
        this.id = id; // Identificador da proposta
        this.numero = numero; // Número da parcela de prestação
        this.valor = valor; // Valor da prestação
        this.dataVencimento = dataVencimento; // Data de vencimento
        this.dataAjustePreco = dataAjustePreco; // Data que deve começar a ocorrer o ajuste de preço
    }
}